export default __webpack_public_path__ + "static/media/me.85071645.png";